var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-col',{staticClass:"d-flex flex-wrap align-center"},_vm._l((_vm.services),function(service){return _c('service',{key:service.id,staticClass:"ma-4",attrs:{"service":service}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }